'use client';

import { useEffect } from 'react';

interface ThemeProviderProps {
    color: string;
    children: React.ReactNode;
}

export function ThemeProvider({ color, children }: ThemeProviderProps) {
    useEffect(() => {
        if (color) {
            document.documentElement.style.setProperty('--primary', color);
            // You might want to calculate foreground colors or shades here
            // For simplicity, we just set the primary color variable
            // In a real app, you'd convert hex to hsl values for tailwind
        }
    }, [color]);

    return <>{children}</>;
}
